import React, { useState } from 'react';
import styled from 'astroturf/react';
import _Button from "CollapsibleList-Button.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/utils/components/CollapsibleList.tsx?styleId=Button";


type Props = {
  children: React.ReactElement[];
  className?: string;
  initialLimit?: number;
};

const Button = /*#__PURE__*/styled("button", null, {
  displayName: "Button",
  styles: _Button
});

const INITIAL_LIMIT = 4;

const CollapsibleList: React.FC<Props> = ({
  className,
  children,
  initialLimit = INITIAL_LIMIT,
}) => {
  const [limit, setLimit] = useState(true);
  const toggleLimit = () => setLimit((l) => !l);

  const childrenArray = React.Children.toArray(children).slice(0, initialLimit);
  // This component can accept a plain array of strings,
  // or an array of React elements.
  // ['item 1', 'item 2', 'item 3']
  // or
  // [<li>item 1</li>, <li>item 2</li>, <li>item 3</li>]
  // This allows custom styling of the list items.
  // We want to make sure we render plain strings inside `li`s though.
  const alreadyWrapped = React.isValidElement(childrenArray[0]);
  const wrappedChildren = alreadyWrapped
    ? childrenArray
    : childrenArray.map((l, i) => <li key={i}>{l}</li>);
  const list = wrappedChildren.slice(0, limit ? initialLimit : Infinity);
  const showButton = childrenArray.length > initialLimit;

  return (
    <>
      <ul className={className}>{list}</ul>
      {showButton && (
        <Button onClick={toggleLimit}>{limit ? 'More' : 'Less'}</Button>
      )}
    </>
  );
};

export default CollapsibleList;
